import { css, keyframes } from 'styled-components';
import { colorTokens } from '../../../tokens/globals/tokens';

export const shimmerRoll = size => keyframes`
  0% {
    background-position: ${size === '100%' ? '100%' : `calc(${size} * -1.5)`} 0;
  }

  100% {
    background-position: ${size === '100%' ? '-200%' : `calc(${size} * 1.5)`} 0;
  }
`;

export const shimmerBase = css`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background-color: ${colorTokens.GlobalBrandGray10};
  background-image: linear-gradient(
    to right,
    ${colorTokens.GlobalBrandGray10} 0%,
    ${colorTokens.GlobalBrandWhite} 20%,
    ${colorTokens.GlobalBrandGray10} 60%,
    ${colorTokens.GlobalBrandGray10} 100%
  );
  background-repeat: no-repeat;
  background-size: 150%;
  border-radius: 6px;
  margin: 2px 0;
  position: relative;
  max-width: 100%;

  table && {
    display: inline-flex;
    vertical-align: top;
  }
`;
